export const formatCreditAmount = (value) => {
  const num = Number(value);
  if (!isNaN(num)) {
    return num % 1 === 0 ? num : num.toFixed(1);
  }
  return value;
};
